import React, { useEffect, useState } from "react";
import { Select, Row, Col } from "antd";
import { Filters } from "../../types/dashboard/filters";
import { stageData, StageKey } from "../../types/dashboard/stageData";

const { Option } = Select;

// ---------- SHARED TYPES ----------
export interface Subdivision {
  value: string;
  label: string;
}

export interface StageItem {
  label: string;
  subdivisions: Subdivision[];
}

// ---------- COMPONENT ----------
interface Props {
  filter: Filters;
  userRole?: string;
  onChange: (filter: Filters) => void;
}

const StageStatusFilters: React.FC<Props> = ({ filter, userRole, onChange }) => {
  const [statuses, setStatuses] = useState<Subdivision[]>([]);

  useEffect(() => {
    if (filter.stage) {
      const st = stageData[filter.stage]?.subdivisions ?? [];
      setStatuses(st);

      if (!st.find((s) => s.value === filter.status)) {
        onChange({ ...filter, status: "" });
      }
    } else {
      setStatuses([]);
      onChange({ ...filter, status: "" });
    }
  }, [filter.stage]);


  return (
    <Row gutter={16}>
      <Col><input type="text" className="search-bar" placeholder="Search by name..." value={filter.name} onChange={(e) => onChange({ name: e.target.value })} /></Col>
      <Col><input type="text" className="search-bar" placeholder="Search by Mobile..." value={filter.mobile} onChange={(e) => onChange({ mobile: e.target.value })} /></Col>
      <Col><input type="text" className="search-bar" placeholder="Search by Assigned..." value={filter.assignedTo} onChange={(e) => onChange({ assignedTo: e.target.value })} /></Col>
      <Col><input type="text" className="search-bar" placeholder="Search by City..." value={filter.city} onChange={(e) => onChange({ city: e.target.value })} /></Col>
    
      {/* Stage Dropdown */}
      <Col>
        <Select
          placeholder="Select Stage"
          style={{ width: 150 }}
          value={filter.stage}
          onChange={(value) => {
            onChange({ ...filter, stage: value as StageKey, status:"" });
          }
            
          }
        >
          <option value="">--Select Followup--</option>
          {Object.entries(stageData).map(([key, data]) => (
            <Option key={key} value={key}>
              {data.label}
            </Option>
          ))}
        </Select>
      </Col>

      {/* Status Dropdown */}
      <Col>
        <Select
          placeholder="Select Status"
          style={{ width: 260 }}
          value={filter.status}
          onChange={(value) =>
            onChange({ ...filter, status: value })
          }
        >
          <option value="">--select Status--</option>
          {statuses.map((s) => (
            <Option key={s.value} value={s.value}>
              {s.label}
            </Option>
          ))}
        </Select>
      </Col>

    </Row>
  );
};

export default StageStatusFilters;
